<template>
  <div :class="isMobile ? 'legal-page legal-page-m' : 'legal-page'">
    <div class="legal-container">
      <router-link class="back-link" :to="{ path: '/download' }">返回下载页</router-link>
      <h1>{{ title }}</h1>
      <h2 class="document-title">{{ documentTitle }}</h2>
      <div class="meta-list">
        <p v-for="item in metaList" :key="item">{{ item }}</p>
      </div>
      <template v-for="(block, index) in blocks">
        <h2 v-if="block.type === 'section'" :key="index" class="section-title">{{ block.text }}</h2>
        <h3 v-else-if="block.type === 'subsection'" :key="index" class="subsection-title">{{ block.text }}</h3>
        <p v-else-if="block.type === 'paragraph'" :key="index" class="legal-paragraph">{{ block.text }}</p>
        <div v-else-if="block.type === 'info'" :key="index" class="info-list">
          <p v-for="item in block.items" :key="item">{{ item }}</p>
        </div>
        <ul v-else-if="block.type === 'list'" :key="index" class="legal-list">
          <li v-for="item in block.items" :key="item">{{ item }}</li>
        </ul>
      </template>
    </div>
    <a class="record-number" href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
      艾感科技（广东）有限公司 粤ICP备18012156号
    </a>
  </div>
</template>

<script>
export default {
  name: "UserAgreement",
  data() {
    return {
      isMobile: window.innerWidth < 780,
      title: "用户协议",
      documentTitle: "艾感智能纸尿裤助手用户协议",
      metaList: ["发布日期：", "生效日期："],
      blocks: [
        { type: "paragraph", text: "欢迎使用艾感智能纸尿裤助手。本协议是您与之间关于下载、安装、使用本 App 及相关服务所订立的协议。" },
        { type: "paragraph", text: "请您在使用本 App 前仔细阅读并充分理解本协议。您下载、安装、登录或使用本 App，即表示您已阅读、理解并同意本协议。" },
        { type: "section", text: "一、服务内容" },
        { type: "paragraph", text: "艾感智能纸尿裤助手是一款用于连接和管理智能纸尿裤相关蓝牙设备的应用，主要功能包括：" },
        { type: "list", items: ["蓝牙设备搜索、连接和绑定", "设备状态查看", "纸尿裤状态提醒", "后台连接状态通知", "设备数据同步", "故障排查和售后支持"] },
        { type: "paragraph", text: "具体功能以实际提供的版本为准。" },
        { type: "section", text: "二、使用条件" },
        { type: "list", items: ["1. 您应为具备完全民事行为能力的用户，或在监护人指导下使用本 App。", "2. 如本 App 用于婴幼儿照护，相关操作应由父母或其他监护人完成。", "3. 您应确保提供的信息真实、准确、完整。", "4. 您应按照产品说明和本 App 提示正确使用智能设备。", "5. 本 App 面向监护人使用，不面向儿童独立使用。如涉及婴幼儿信息填写、设备绑定、照护记录等操作，应由父母或其他监护人完成。"] },
        { type: "section", text: "三、企业/客户内部分发说明" },
        { type: "paragraph", text: "本 App 主要用于，下载页面为：" },
        { type: "info", items: ["https://www.aisensing.cn/download"] },
        { type: "paragraph", text: "请您仅从官方或经授权的渠道下载安装本 App。因从非官方渠道下载、安装、使用 App 导致的风险，由用户自行承担。" },
        { type: "section", text: "四、用户行为规范" },
        { type: "paragraph", text: "您不得利用本 App 从事以下行为：" },
        { type: "list", items: ["违反法律法规或监管要求的行为", "破坏 App、服务器或蓝牙设备正常运行的行为", "反向工程、破解、篡改、二次打包或恶意传播 App", "冒用他人身份或设备信息", "上传、传播违法或侵权内容", "未经授权将 App 用于非约定客户或非授权项目"] },
        { type: "section", text: "五、蓝牙连接和后台提醒说明" },
        { type: "paragraph", text: "为实现设备连接和提醒功能，本 App 需要使用蓝牙、网络、通知和前台服务等能力。" },
        { type: "paragraph", text: "当您开启后台连接或提醒功能时，App 可能通过系统通知栏显示运行状态。您可以在系统设置中关闭相关权限，但关闭后可能影响设备连接、提醒通知或后台运行效果。" },
        { type: "section", text: "六、设备和数据说明" },
        { type: "paragraph", text: "本 App 展示的设备状态、提醒信息和检测数据仅用于日常照护辅助参考，不应替代人工判断、医疗诊断或专业护理建议。" },
        { type: "paragraph", text: "如设备状态异常、提醒异常或实际情况与 App 显示不一致，请以现场观察和实际照护判断为准，并及时联系。" },
        { type: "section", text: "七、费用说明" },
        { type: "paragraph", text: "本 App 当前提供。" },
        { type: "paragraph", text: "如涉及设备购买、服务订阅、企业项目费用或增值服务，具体费用以您与或授权合作方签署的订单、合同或报价为准。" },
        { type: "section", text: "八、知识产权" },
        { type: "paragraph", text: "本 App 及相关软件、界面、文字、图片、商标、标识、技术和数据服务的知识产权归或相关权利人所有。" },
        { type: "paragraph", text: "未经书面许可，任何人不得复制、修改、传播、出租、出售、反向工程或用于其他商业目的。" },
        { type: "section", text: "九、隐私保护" },
        { type: "paragraph", text: "我们重视用户隐私和个人信息保护。关于我们如何收集、使用、存储和保护您的信息，请阅读《艾感智能纸尿裤助手隐私政策》。" },
        { type: "section", text: "十、服务变更、中断或终止" },
        { type: "paragraph", text: "因以下原因，我们可能变更、中断或终止部分服务：" },
        { type: "list", items: ["系统维护或升级", "蓝牙设备、手机系统或网络环境限制", "服务器故障或安全事件", "法律法规或监管要求", "客户项目结束或授权终止", "不可抗力或其他合理原因"] },
        { type: "paragraph", text: "我们将尽力减少对用户的影响。" },
        { type: "section", text: "十一、免责声明" },
        { type: "paragraph", text: "在法律允许范围内，因以下情况造成的损失，我们不承担责任：" },
        { type: "list", items: ["用户未按说明使用设备或 App", "手机系统权限关闭、后台限制或网络异常", "蓝牙设备电量不足、损坏、距离过远或环境干扰", "非官方渠道下载、安装或使用 App", "第三方设备、系统、网络或服务异常", "不可抗力或无法合理控制的原因"] },
        { type: "section", text: "十二、责任限制" },
        { type: "paragraph", text: "本 App 提供的提醒和状态信息为辅助参考。对于因用户未及时查看提醒、未正确使用设备、环境干扰或其他非本公司原因导致的损失，我们在法律允许范围内不承担超出实际服务范围的责任。" },
        { type: "section", text: "十三、协议更新" },
        { type: "paragraph", text: "我们可能根据产品功能、业务模式或法律法规要求更新本协议。" },
        { type: "paragraph", text: "如协议发生重大变化，我们会通过 App 提示、下载页面公告或其他合理方式通知您。您继续使用本 App，即表示您同意更新后的协议。" },
        { type: "section", text: "十四、法律适用与争议解决" },
        { type: "paragraph", text: "本协议的订立、履行、解释及争议解决适用中华人民共和国法律。" },
        { type: "paragraph", text: "因本协议产生的争议，双方应友好协商解决；协商不成的，任一方可向有管辖权的人民法院提起诉讼。" },
        { type: "section", text: "十五、联系我们" },
        { type: "info", items: ["公司名称：艾感科技（广东）有限公司", "注册地址：佛山市禅城区张槎街道华兴路22号顺盈嘉智能科技园C座八楼C801", "联系邮箱：hongying@aisensing.cn", "客服电话：0757-85335951"] }
      ]
    }
  },
  mounted() {
    window.addEventListener("resize", this.initFunc)
  },
  destroyed() {
    window.removeEventListener("resize", this.initFunc)
  },
  methods: {
    initFunc() {
      this.isMobile = window.innerWidth < 780
    }
  }
}
</script>

<style scoped lang="less">
.legal-page {
  background: #f6f8fb;
  color: #26333d;
  padding: 40px 24px 70px;
  box-sizing: border-box;

  .legal-container {
    max-width: 960px;
    margin: 0 auto;
    padding: 38px 46px;
    background: #fff;
    border: 1px solid #e7edf3;
    border-radius: 8px;
    box-sizing: border-box;
  }

  .back-link {
    display: inline-block;
    margin-bottom: 24px;
    color: #0f8e83;
    font-size: 13px;
    line-height: 24px;
  }

  h1 {
    margin: 0 0 12px;
    color: #1d2730;
    font-size: 28px;
    line-height: 46px;
    font-weight: bold;
    text-align: left;
  }

  .document-title {
    margin: 0 0 18px;
    color: #26333d;
    font-size: 20px;
    line-height: 34px;
    font-weight: bold;
    text-align: left;
  }

  .meta-list {
    margin-bottom: 28px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e7edf3;

    p {
      margin: 0 0 6px;
      color: #64727f;
      font-size: 13px;
      line-height: 24px;
      text-align: left;
    }
  }

  .section-title {
    margin: 34px 0 14px;
    color: #0f8e83;
    font-size: 20px;
    line-height: 32px;
    font-weight: bold;
    text-align: left;
  }

  .subsection-title {
    margin: 24px 0 10px;
    color: #26333d;
    font-size: 16px;
    line-height: 28px;
    font-weight: bold;
    text-align: left;
  }

  .legal-paragraph,
  .info-list p,
  .legal-list li {
    color: #3e4b56;
    font-size: 14px;
    line-height: 30px;
    text-align: left;
  }

  .legal-paragraph {
    margin: 0 0 12px;
  }

  .info-list {
    margin: 8px 0 14px;
    padding: 14px 18px;
    background: #f7fbfb;
    border-left: 3px solid #16b7a9;

    p {
      margin: 0 0 4px;
      word-break: break-word;
    }
  }

  .legal-list {
    margin: 8px 0 14px;
    padding-left: 22px;

    li {
      margin-bottom: 4px;
    }
  }

  .record-number {
    display: block;
    margin: 28px auto 0;
    padding: 0 24px;
    color: #8b97a3;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
    box-sizing: border-box;
  }
}

.legal-page-m {
  padding: 0.3rem 0.24rem 1rem;

  .legal-container {
    padding: 0.48rem 0.34rem;
    border-radius: 0.12rem;
  }

  .back-link {
    margin-bottom: 0.34rem;
    font-size: 0.32rem;
    line-height: 0.48rem;
  }

  h1 {
    font-size: 0.58rem;
    line-height: 0.76rem;
  }

  .document-title {
    font-size: 0.42rem;
    line-height: 0.6rem;
  }

  .meta-list p,
  .legal-paragraph,
  .info-list p,
  .legal-list li {
    font-size: 0.32rem;
    line-height: 0.58rem;
  }

  .section-title {
    margin-top: 0.58rem;
    font-size: 0.42rem;
    line-height: 0.6rem;
  }

  .subsection-title {
    margin-top: 0.42rem;
    font-size: 0.36rem;
    line-height: 0.54rem;
  }

  .info-list {
    padding: 0.24rem 0.28rem;
  }

  .record-number {
    display: block;
    margin-top: 0.42rem;
    padding: 0 0.28rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
  }
}
</style>
